import { inject, Injectable } from '@angular/core';
import { DataBagService } from '@/common/data-bag.service';
import { InfoboxService } from '@/common/infobox/infobox.service';
import { Result } from '@/reservation/reservation.model';
import {
	BankAccount,
	BankAccountUpdatePayload,
	BulkUpdateBankAccountPayload,
} from './organization-bank-accounts.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class OrganizationBankAccountsApiService {
	private readonly httpClient = inject(HttpClient);
	private readonly bag = inject(DataBagService);
	private readonly infobox = inject(InfoboxService);
	private readonly apiUrl = environment.apiUrl;

	getOrganizationBankAccounts(params: string): Observable<BankAccount[]> {
		return this.httpClient
			.get<Result<BankAccount>>(`${this.apiUrl}/bank_account/${params}`)
			.pipe(map((result) => result.results));
	}

	addOrganizationBankAccount(bankAccountData: BankAccountUpdatePayload): Observable<BankAccountUpdatePayload> {
		return this.httpClient.post<BankAccountUpdatePayload>(`${this.apiUrl}/bank_account/`, bankAccountData);
	}

	editOrganizationBankAccount(
		bankAccountId: number,
		bankAccountData: BankAccountUpdatePayload,
	): Observable<BankAccountUpdatePayload> {
		return this.httpClient.put<BankAccountUpdatePayload>(
			`${this.apiUrl}/bank_account/${bankAccountId}/`,
			bankAccountData,
		);
	}

	patchOrganizationBankAccount(
		bankAccountId: number,
		bankAccountData: Partial<BankAccountUpdatePayload>,
	): Observable<BankAccountUpdatePayload> {
		return this.httpClient.patch<BankAccountUpdatePayload>(
			`${this.apiUrl}/bank_account/${bankAccountId}/`,
			bankAccountData,
		);
	}

	bankAccountBulkCreate(bankAccountData: BulkUpdateBankAccountPayload[]): Observable<BulkUpdateBankAccountPayload[]> {
		return this.httpClient.post<BulkUpdateBankAccountPayload[]>(
			`${this.apiUrl}/bank_account/bulk_create/`,
			bankAccountData,
		);
	}
}
